import React from "react";
import { addVehicleEffect } from "../../../../stores/FleetsStore/FleetsStore.effects";
import { AddButton } from "../../../../components/Table";
import FleetFormModal from "../FleetFormModal/FleetFormModal";

const AddFleet: React.FC = () => {
  return (
    <FleetFormModal
      effect={addVehicleEffect}
      title="Adicionar frota"
      confirmText="Confirmar"
      cancelText="Cancelar"
      TriggerComponent={
        <AddButton>Adicionar frota</AddButton>
      }
    />
  );
};

export default AddFleet;
